var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"13","height":"8","viewBox":"0 0 13 8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M1.91 0.296875L6.5 4.87687L11.09 0.296875L12.5 1.70687L6.5 7.70687L0.5 1.70687L1.91 0.296875Z","fill":"#404A57"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }